var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require('@/images/empty/'+_vm.img + '.png')}}),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.desc)}}),_c('div',{staticClass:"bottom"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }